import type { ModelData } from '../../types'

export const dragonTrojstronne: { [key: string]: ModelData } = {
  'dragon-2c': {
    id: 'dragon-2c',
    name: 'DRAGON 2C',
    power: '12 kW',
    type: 'powietrzny nofusion',
    glassType: 'narozna' as const,
    image: 'images/dragon-2c.jpg',
    emailSubject: 'Zapytanie - DRAGON 2C',
    description: 'Trójstronne przeszklenie zapewnia wizję ognia w palenisku o bardzo dużym spektrum.',
    specialNote: 'Trójstronne przeszklenie zapewnia wizję ognia w palenisku o bardzo dużym spektrum.',
    basePrices: {
      lift: {
        single: 15840
      }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        lift: { none: 0, 'recessed-lift-15': 900 } // Bez blendy (0 zł) i LIFT 15cm (900 zł)
      },
      fusion: { none: 0, fusion: 500 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '11,5 kW',
      efficiency: '80,0%',
      energyClass: 'A',
      glassSize: '764+360 x 478 mm',
      insertSize: '764 x 1488-2003 x 540 mm',
      fireplaceSize: '450 x 520 x 285 mm',
      maxLogLength: '510 mm',
      weight: '257 kg'
    },
        labels: {
      variant: { 
        lift: 'POWERLIFT - tylko podnoszenie do góry' 
      },
      glass: { 
        single: 'Szyba trójstronna dzielona'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'recessed-lift-15': 'LIFT 15mm (RL15) bez wywinięcia'
      },
      fusion: { 
        none: 'Brak'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2C',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2C w konfiguracji:\n\nModel: DRAGON 2C\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  }
}
